import { compose, nest, withProps } from "recompose";
import * as hoc from "modules/user/auth/hoc";
import { isInsider } from "modules/user/auth/model";
import { Success } from "components/common/referral";
import { Overlay } from "components/common/insider";

export default compose(
  hoc.authorized(isInsider),
  withProps({
    text: "An invitation was sent to future Insiders in The Lobby"
  })
)(nest(Overlay, Success));



// WEBPACK FOOTER //
// ./src/components/pages/Insider/ReferralSuccess/index.js